//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.1.0 (NJsonSchema v11.5.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming



export interface AccesoDirectoEditModel {
    id: number;
    colegioId: number;
    abrirEnNuevaVentana: boolean;
    titulo: string | null;
    urlEnlace: string | null;
    caratula: string | null;
}

export interface AccesoDirectoHomeItem {
    titulo: string | null;
    urlEnlace: string | null;
    urlCaratula: string | null;
    abrirEnNuevaVentana: boolean;
}

export interface AccesoDirectoListItem {
    id: number;
    titulo: string | null;
}

export interface AccesoDirectoListItemPaginatedList {
    resultsPerPage: number;
    resultsCurrentPage: number;
    currentPage: number;
    totalCount: number;
    orderByColumn: string | null;
    orderMode: SortDirection;
    items: AccesoDirectoListItem[] | null;
}

export interface SearchModelBase {
    noTotalCount: boolean;
    currentPage: number;
    rowsPerPage: number;
    currentPageRows: number;
    bypassAutomaticSort: boolean;
    orderByColumn: string | null;
    orderMode: SortDirection;
}

export interface AccesoDirectoSearch extends SearchModelBase {
    colegioId: number;
}

export interface Actividad {
    id: number;
    externalId: string | null;
    unidadId: number;
    unidad: Unidad;
    nombre: string | null;
    orden: number;
}

export interface AlumnoListItem {
    id: number;
    nombre: string | null;
    apellidos: string | null;
    cursoEscolar: string | null;
    clase: string | null;
    fechaUltimoAcceso: Date | null;
    credenciales: string | null;
    readonly haAccedido: boolean;
}

export interface AlumnoListItemPaginatedList {
    resultsPerPage: number;
    resultsCurrentPage: number;
    currentPage: number;
    totalCount: number;
    orderByColumn: string | null;
    orderMode: SortDirection;
    items: AlumnoListItem[] | null;
}

export interface AlumnosDeClaseSearch extends SearchModelBase {
    colegioId: number;
    claseMateriaId: number | null;
    nombre: string | null;
    apellidos: string | null;
    borrado: boolean;
    repetidor: boolean;
    claseId: number | null;
}

export enum ApprovedState {
    Pending = "Pending",
    Approved = "Approved",
    Discarded = "Discarded",
}

export interface AsignacionListaLibros {
    id: number;
    listaLibrosColegioId: number;
    userId: number | null;
    nivelEducativoId: number;
    nivelEducativo: NivelEducativo;
    estado: number | null;
}

export interface BasicData {
    id: number;
    nombre: string | null;
    tipoUsuario: TipoUsuario;
    claseActualId: number | null;
    claseActual: string | null;
}

export interface BurlingtonOperationResult {
    isOk: boolean;
    response: string | null;
    request: string | null;
}

export interface CalificacionInfo {
    usuarioId: number;
    actividadId: number;
    calificacion: number;
    urlResultados: string | null;
}

export interface Campanna {
    anno: number;
}

export interface Carga {
    id: number;
    colegioId: number;
    colegio: Colegio;
    usuarioId: number;
    usuario: UsuarioColegio;
    fecha: Date;
    items: CargaItem[] | null;
    tipoCarga: TipoCarga;
    ficheroUrl: string | null;
}

export interface CargaEditModel {
    id: number;
    fileUrl: string | null;
    tipoCarga: TipoCarga;
    usuarioId: number;
    colegioId: number;
    actualizarSiExiste: boolean;
    noCrearLicencias: boolean;
    tipoLicencia: TipoLicencia;
    crearEstructuraColegio: boolean;
    noImportarCredenciales: boolean;
}

export interface CargaGetDetailResult {
    id: number;
    fecha: Date;
    tipoCarga: TipoCarga;
    ficheroUrl: string | null;
    correctos: number;
    duplicados: number;
    erroneos: number;
}

export interface CargaItem {
    id: number;
    carga: Carga;
    cargaId: number;
    filaExcel: number;
    estado: EstadoCargaItem;
    entidad: string | null;
    error: string | null;
}

export interface CargaItemListItem {
    id: number;
    cargaId: number;
    filaExcel: number;
    estado: EstadoCargaItem;
    entidad: string | null;
    error: string | null;
}

export interface CargaListItem {
    id: number;
    colegioId: number;
    usuarioId: number;
    usuario: string | null;
    fecha: Date;
    tipoCarga: TipoCarga;
    ficheroUrl: string | null;
    items: CargaItemListItem[] | null;
}

export interface CargaListItemPaginatedList {
    resultsPerPage: number;
    resultsCurrentPage: number;
    currentPage: number;
    totalCount: number;
    orderByColumn: string | null;
    orderMode: SortDirection;
    items: CargaListItem[] | null;
}

export interface CargaPersistResult {
    cargaId: number;
    numRowsOk: number;
    numRowsError: number;
    numRowsDuplicated: number;
    mensajeGlobal: string | null;
}

export interface CargasSearch extends SearchModelBase {
    cargaId: number | null;
    colegioId: number;
}

export enum CategoriaColegio {
    Publico = "Publico",
    Concertado = "Concertado",
    Privado = "Privado",
}

export interface Clase {
    id: number;
    nivelEducativoId: number;
    nivelEducativo: NivelEducativo;
    nombre: string | null;
    orden: number;
    identificadorTienda: string | null;
    sincronizar: boolean;
    claseMaterias: ClaseMateria[] | null;
    alumnos: UsuarioColegio[] | null;
}

export interface ClaseListItem {
    id: number;
    clase: string | null;
    nivelEducativoId: number;
    nivelEducativo: string | null;
}

export interface ClaseListItemPaginatedList {
    resultsPerPage: number;
    resultsCurrentPage: number;
    currentPage: number;
    totalCount: number;
    orderByColumn: string | null;
    orderMode: SortDirection;
    items: ClaseListItem[] | null;
}

export interface ClaseMateria {
    id: number;
    nombre: string | null;
    claseId: number;
    clase: Clase;
    origen: OrigenUsuario;
    borrado: boolean;
    matriculas: Matricula[] | null;
    claseMateriaProductosTienda: ClaseMateriaProductoTienda[] | null;
}

export interface ClaseMateriaConError {
    id: number;
    claseMateria: string | null;
    clase: string | null;
    claseId: number;
    cursoEscolarId: number;
}

export interface ClaseMateriaContenidosEditModel {
    id: number;
    claseMateriaId: number;
    nivelContenidoId: number | null;
    numLicencias: number;
    tipoUsuario: TipoUsuarioContenido;
}

export interface ClaseMateriaEditModel {
    id: number;
    nombre: string | null;
    claseId: number;
    origen: OrigenUsuario;
    borrado: boolean;
    contenidoId: number | null;
    contenido: string | null;
    numMatriculas: number | null;
    claseMateriaContenidos: ClaseMateriaContenidosEditModel[] | null;
    claseMateriaProductosTienda: ClaseMateriaProductoTiendaEditModel[] | null;
}

export interface ClaseMateriaGetCalificacionesResult {
    usuarios: UsuarioInfo[] | null;
    calificaciones: CalificacionInfo[] | null;
}

export interface ClaseMateriaListItem {
    id: number;
    nombre: string | null;
    clase: string | null;
    claseId: number;
    nivelContenidoId: number | null;
    contenido: string | null;
    contenidoId: number | null;
    editorial: Editorial;
    borrado: boolean;
    origen: OrigenUsuario;
}

export interface ClaseMateriaListItemPaginatedList {
    resultsPerPage: number;
    resultsCurrentPage: number;
    currentPage: number;
    totalCount: number;
    orderByColumn: string | null;
    orderMode: SortDirection;
    items: ClaseMateriaListItem[] | null;
}

export interface ClaseMateriaProductoTienda {
    id: number;
    claseMateriaId: number | null;
    created: Date | null;
    claseMateria: ClaseMateria;
    nivelItemCatalogoEditorialId: number | null;
}

export interface ClaseMateriaProductoTiendaEditModel {
    id: number;
    claseMateriaId: number;
    nivelItemCatalogoEditorialId: number | null;
    numLicencias: number;
    tipoUsuario: TipoUsuarioContenido;
}

export interface ClaseMateriaSearch extends SearchModelBase {
    colegioId: number;
    claseId: number | null;
    profesorId: number | null;
}

export interface ClasesSearch extends SearchModelBase {
    colegioId: number;
    profesorId: number | null;
    alumnoId: number | null;
    posibles: boolean;
    nivelEducativoId: number | null;
}

export interface Colegio {
    id: number;
    name: string | null;
    allowedLoginMethods: string | null;
    dominiosAutorizados: string | null;
    comunidadAutonomaId: number | null;
    foto: Photo;
    usuariosColegio: UsuarioColegio[] | null;
    credencialesEditoriales: ColegioCredencialEditorial[] | null;
    cursosEscolares: CursoEscolar[] | null;
    cargas: Carga[] | null;
    resultadoActividades: ResultadoActividad[] | null;
    nombreColegioPedidosTienda: string | null;
    sincronizar: boolean;
    sincronizarLicencias: boolean;
    omitirCreacionListas: boolean;
    comunicarAsignacionLicencias: boolean;
    comunicarCredencialesLicenciasAlAsignar: boolean;
    comercialResponsableId: number | null;
    emailColegio: string | null;
    allowGoogleLogin: boolean;
    allowMicrosoftLogin: boolean;
    allowCustomLogin: boolean;
    externalId: string | null;
    codMinisterio: string | null;
    localidad: string | null;
    calle: string | null;
    factEmail: string | null;
    factEnviarA: string | null;
    telefonoContacto: string | null;
    factNif: string | null;
    factNombre: string | null;
    factDireccion: string | null;
    factPoblacion: string | null;
    factProvincia: string | null;
    factCodigoPostal: string | null;
    factOficinaContable: string | null;
    factOrganoGestor: string | null;
    factUnidadTramitadora: string | null;
    categoria: CategoriaColegio;
    institucionId: number | null;
    institucion: Institucion;
}

export interface ColegioCredencialEditorial {
    id: number;
    nombre: string | null;
    colegioId: number;
    colegio: Colegio;
    editorial: Editorial;
    tipoLicencia: TipoAccesoLicencia;
    datos: string | null;
    deshabilitarAcceso: boolean;
    mensajeDeshabilitarAcceso: string | null;
    urlAcceso: string | null;
    isbn: string | null;
}

export interface ColegioCredencialesEditorialesEditModel {
    id: number;
    colegioId: number;
    nombre: string | null;
    editorial: Editorial;
    datos: string | null;
    tipoLicencia: TipoAccesoLicencia;
    deshabilitarAcceso: boolean;
    mensajeDeshabilitarAcceso: string | null;
    urlAcceso: string | null;
    mensajeAcceso: string | null;
    mostrarCredencialAlAcceder: boolean;
    contenidoNombre: string | null;
    contenidoIsbn: string | null;
}

export interface ColegioCredencialesEditorialesListItem {
    id: number;
    nombre: string | null;
    editorial: Editorial;
    contenidoIsbn: string | null;
    contenidoNombre: string | null;
    tipoLicencia: TipoAccesoLicencia;
}

export interface ColegioCredencialesEditorialesListItemPaginatedList {
    resultsPerPage: number;
    resultsCurrentPage: number;
    currentPage: number;
    totalCount: number;
    orderByColumn: string | null;
    orderMode: SortDirection;
    items: ColegioCredencialesEditorialesListItem[] | null;
}

export interface ColegioCredencialesEditorialesSearch extends SearchModelBase {
    colegioId: number;
    nombre: string | null;
    editorial: Editorial;
}

export interface ColegioDiagnosticoResult {
    clasesMateriasNombreMal: ClaseMateriaConError[] | null;
    editorialesSinCredenciales: EditorialSinCredenciales[] | null;
    contenidosSinEditorial: ContenidoSinEditorial[] | null;
    licenciasSinConfigurar: LicenciaSinConfigurar[] | null;
    cursosAcademicosAnomalias: CursosEscolaresDiagResult;
    cursosEscolaresDiag: CursosEscolaresDiagResult;
    matriculasSinLicencia: MatriculasSinLicencia[] | null;
}

export interface ColegioListItem {
    id: number;
    nombre: string | null;
    sincronizar: boolean;
}

export interface ColegioUsuarioActivateModel {
    colegioUsuarioIds: number[] | null;
}

export interface ColegioUsuarioActivateResult {
    numActivated: number;
}

export interface ColegioUsuarioBaseModel {
    id: number;
    colegioId: number;
    login: string | null;
    nombre: string | null;
    apellidos: string | null;
    foto: string | null;
    origen: OrigenUsuario;
    claseActualId: number | null;
    claseActual: string | null;
    tipoUsuario: TipoUsuario;
    estado: EstadoUsuario;
    fechaUltimoAcceso: Date | null;
    created: Date;
    modified: Date;
    borrado: boolean;
    password: string | null;
    passwordConfirmar: string | null;
    passwordError: string | null;
    allowCustomLogin: boolean;
}

export interface ColegioUsuarioBulkDeleteModel {
    colegioUsuarioIds: number[] | null;
    estado: EstadoUsuario;
}

export interface ColegioUsuarioCustomCreateModel extends ColegioUsuarioBaseModel {
}

export interface ColegioUsuarioDeleteResult {
}

export interface ColegioUsuarioEditModel extends ColegioUsuarioBaseModel {
}

export interface ColegioUsuarioListItem {
    id: number;
    nombre: string | null;
    apellidos: string | null;
    nombreCompleto: string | null;
    login: string | null;
    tipoUsuario: TipoUsuario;
    created: Date;
    fechaUltimoAcceso: Date | null;
    estado: EstadoUsuario;
    cursoEscolar: string | null;
    clase: string | null;
    borrado: boolean;
    readonly protegidoBorrado: boolean;
}

export interface ColegioUsuarioListItemPaginatedList {
    resultsPerPage: number;
    resultsCurrentPage: number;
    currentPage: number;
    totalCount: number;
    orderByColumn: string | null;
    orderMode: SortDirection;
    items: ColegioUsuarioListItem[] | null;
}

export interface ColegioUsuariosChangeClassModel {
    colegioUsuarioIds: number[] | null;
    claseId: number;
}

export interface ColegioUsuariosChangeClassResult {
    numChanged: number;
}

export interface ColegioUsuariosSearchBase extends SearchModelBase {
    colegioId: number;
    nombre: string | null;
    apellidos: string | null;
    login: string | null;
    tipoUsuario: TipoUsuario;
    claseId: number | null;
    claseMateriaId: number | null;
    cursoEscolarId: number;
    profesorId: number | null;
    estado: EstadoUsuario;
    repetidor: boolean;
    pendienteValidar: boolean;
    soloAlumnosMatriculados: boolean;
    borrado: boolean;
}

export interface ColegioUsuariosExcelExport extends ColegioUsuariosSearchBase {
}

export interface ColegioUsuariosPlanificarUnionMessage {
    colegioId: number;
    usuarioOrigenId: number;
    usuarioDestinoId: number;
}

export interface ColegioUsuariosSearch extends ColegioUsuariosSearchBase {
}

export interface ColegioUsuariosUndeleteModel {
    colegioUsuarioIds: number[] | null;
}

export interface ColegioUsuariosUndeleteResult {
    numActivated: number;
}

export interface ColegioUsuariosUnirMessage {
    colegioId: number;
    usuarioOrigenId: number;
    usuarioDestinoId: number;
    usuario: string | null;
    confirmado: boolean;
    huellaPlan: string | null;
    anadirAliasEmailOrigen: boolean;
    resoluciones: ResolucionConflictoCredencial[] | null;
    resolucionCursosAnteriores: ResolucionConflictoUnion;
}

export interface ComprasPosiblesItem {
    contenidoId: number;
    nombre: string | null;
    clase: string | null;
    caratula: string | null;
    editorial: Editorial;
}

export interface CompromisoAceptarRequest {
    colegioId: number;
    compromisoId: number;
    aceptado: boolean;
}

export interface CompromisoAceptarResponse {
    compromisoId: number;
}

export interface CompromisoListItem {
    id: number;
    colegioCampannaId: number;
    colegioId: number;
    campannaId: number;
    tipoCompromiso: TipoCompromiso;
    estado: EstadoCompromiso;
    fechaPublicado: Date | null;
    fechaATC: Date | null;
    fechaColegio: Date | null;
    fechaComercial: Date | null;
    tituloPublicado: string | null;
    descripcionPublicado: string | null;
    responsableAtc: boolean | null;
    responsableComercial: boolean | null;
    responsableColegio: boolean | null;
    documentoAsociado: string | null;
}

export interface CompromisoListItemPaginatedList {
    resultsPerPage: number;
    resultsCurrentPage: number;
    currentPage: number;
    totalCount: number;
    orderByColumn: string | null;
    orderMode: SortDirection;
    items: CompromisoListItem[] | null;
}

export interface CompromisosSearch extends SearchModelBase {
    colegioId: number | null;
    campannaId: number | null;
    mostrarPendientesDeAceptar: boolean | null;
}

export interface ComunidadAutonomaListItem {
    id: number;
    nombre: string | null;
}

export interface ConflictoCredencialUnion {
    licenciaEliminarId: number;
    licenciaDestinoId: number;
    cursoEscolar: string | null;
    clase: string | null;
    titulo: string | null;
    isbn: string | null;
    credencialEliminar: CredencialUnionInfo;
    credencialDestino: CredencialUnionInfo;
    recomendada: ResolucionConflictoUnion;
}

export interface ContadoresUnionUsuariosColegio {
    matriculasATraspasar: number;
    matriculasDuplicadas: number;
    licenciasConCredencialesATraspasar: number;
    licenciasSinCredencialesATraspasar: number;
    licenciasADescartar: number;
    conflictos: number;
}

export interface ContenidoExternoModel {
    titulo: string | null;
    contenido: string | null;
}

export interface ContenidoSinEditorial {
    id: number | null;
    nombre: string | null;
}

export interface ContenidosColegioChangeAccesoMessage {
    contenidoIds: number[] | null;
    tipoAccesoPorDefecto: TipoAccesoLicencia;
    mostrarAccesoDirecto: boolean;
    mensajeAcceso: string | null;
}

export interface ContenidosColegioEditModel {
    id: number;
    nombre: string | null;
    isbn: string | null;
    caratula: string | null;
    editorial: Editorial;
    tipoAccesoPorDefecto: TipoAccesoLicencia;
    mensajeAcceso: string | null;
    mostrarAccesoDirecto: boolean | null;
}

export interface ContenidosSearchBase extends SearchModelBase {
    nombre: string | null;
    isbn: string | null;
    editorial: Editorial;
    activo: YesNo;
    cursoEscolarId: number | null;
    tipoUsuario: TipoUsuarioContenido;
}

export interface ContenidosColegioSearchBase extends ContenidosSearchBase {
    excluirLicenciasUsuarioId: number | null;
    usuarioColegioId: number | null;
    nivelEducativoId: number | null;
    claseId: number | null;
    showOnlySchoolContents: boolean;
    mostrarNivelesEducativos: boolean;
    incluirNoConfigurados: boolean;
}

export interface ContenidosColegioExcelExport extends ContenidosColegioSearchBase {
}

export interface ContenidosDigitalesListItem {
    id: number;
    nombre: string | null;
    caratula: string | null;
    isbn: string | null;
    editorial: Editorial;
    nivelesEducativos: string | null;
    cursoEscolar: string | null;
    tipoUsuario: TipoUsuarioContenido;
    tipoContenido: TipoContenido;
}

export interface ContenidosDigitalesColegioListItem extends ContenidosDigitalesListItem {
    tipoAccesoPorDefectoStr: string | null;
    readonly tipoAccesoPorDefecto: TipoAccesoLicencia[] | null;
    mostrarAccesoDirectoStr: string | null;
    readonly mostrarAccesoDirecto: boolean[] | null;
}

export interface ContenidosDigitalesColegioListItemPaginatedList {
    resultsPerPage: number;
    resultsCurrentPage: number;
    currentPage: number;
    totalCount: number;
    orderByColumn: string | null;
    orderMode: SortDirection;
    items: ContenidosDigitalesColegioListItem[] | null;
}

export interface ContenidosDigitalesColegioSearch extends ContenidosColegioSearchBase {
    showAccessData: boolean;
}

export interface ContenidosPapelColegioListItem {
    id: number;
    nombre: string | null;
    sku: string | null;
    itemCatalogoEditorialId: number | null;
    editorial: Editorial;
    nivelesEducativos: string | null;
    cursoEscolar: string | null;
}

export interface ContenidosPapelColegioListItemPaginatedList {
    resultsPerPage: number;
    resultsCurrentPage: number;
    currentPage: number;
    totalCount: number;
    orderByColumn: string | null;
    orderMode: SortDirection;
    items: ContenidosPapelColegioListItem[] | null;
}

export interface ContenidosPapelColegioSearch extends SearchModelBase {
    colegioId: number;
    nombre: string | null;
    sku: string | null;
    editorial: Editorial;
    cursoEscolarId: number | null;
    excluirLicenciasUsuarioId: number | null;
    usuarioColegioId: number | null;
    nivelEducativoId: number | null;
    claseId: number | null;
    showOnlySchoolContents: boolean;
}

export interface CredencialLicencia {
    id: number;
    campannaId: number;
    campanna: Campanna;
    isbn: string | null;
    codigoLicencia: string | null;
    disponibleTodosColegios: boolean;
    fechaValidez: Date | null;
    fechaAsignacion: Date | null;
    fechaDevolucion: Date | null;
    ultimaDesasignacion: Date | null;
    deshabilitado: boolean | null;
    observacionesUsuario: string | null;
    importacionId: number | null;
    observacionesAsignacion: string | null;
    licenciasContenido: LicenciaContenido[] | null;
    credencialesColegio: CredencialLicenciaColegio[] | null;
}

export interface CredencialLicenciaColegio {
    id: number;
    colegioId: number;
    licenciaId: number;
    credencial: CredencialLicencia;
}

export interface CredencialUnionInfo {
    licenciaContenidoId: number;
    codigo: string | null;
    fechaAsignacion: Date | null;
    ultimoAcceso: Date | null;
    notificada: Date | null;
    delAlmacen: boolean;
    volveriaAlAlmacen: boolean;
}

export interface CursoEscolar {
    id: number;
    colegioId: number;
    colegio: Colegio;
    nombre: string | null;
    campannaId: number;
    campanna: Campanna;
    activo: boolean;
    visibleAlumnos: boolean;
    contenidoAccesibleAlumnos: boolean;
    fechaInicio: Date;
    fechaFin: Date | null;
    fechaInicioCampagna: Date | null;
    fechaFinCampagna: Date | null;
    etapas: Etapa[] | null;
}

export interface CursoEscolarEditModel {
    id: number;
    nombre: string | null;
    activo: boolean;
    visibleAlumnos: boolean;
    contenidoAccesibleAlumnos: boolean;
    fechaInicio: Date;
    fechaFin: Date;
    campannaId: number;
    campanna: string | null;
    fechaInicioCampagna: Date;
    fechaFinCampagna: Date;
    etapas: EtapaEditModel[] | null;
    movimientosEstudiantes: MovimientoEstudiantesNivelModel[] | null;
}

export interface CursoEscolarListItem {
    id: number;
    nombre: string | null;
    campannaId: number;
    campanna: string | null;
    activo: boolean;
    visibleAlumnos: boolean;
    contenidoAccesibleAlumnos: boolean;
    fechaInicio: Date;
    fechaInicioCampagna: Date | null;
    fechaFinCampagna: Date | null;
}

export interface CursoEscolarListItemPaginatedList {
    resultsPerPage: number;
    resultsCurrentPage: number;
    currentPage: number;
    totalCount: number;
    orderByColumn: string | null;
    orderMode: SortDirection;
    items: CursoEscolarListItem[] | null;
}

export interface CursoEscolarSearch extends SearchModelBase {
    colegioId: number;
    nombre: string | null;
    activo: boolean | null;
    visibleAlumnos: boolean | null;
}

export interface CursosEscolaresDiagResult {
    noHayActivos: boolean;
    activosSinAccesoAlumnos: boolean;
    multiplesActivos: boolean;
}

export interface DocumentUploadResult {
    documentUrl: string | null;
    previewItem: any | null;
    numItemsRead: number;
    state: ApprovedState;
}

export enum Editorial {
    None = "None",
    Santillana = "Santillana",
    SM = "SM",
    Anaya = "Anaya",
    Edelvives = "Edelvives",
    Edebe = "Edebe",
    TekmanBooks = "TekmanBooks",
    Burlington = "Burlington",
    Casals = "Casals",
    Cambridge = "Cambridge",
    Donostiarra = "Donostiarra",
    McGrawHill = "McGrawHill",
    Editex = "Editex",
    Macmillan = "Macmillan",
    Teide = "Teide",
    ScienceBits = "ScienceBits",
    VicensVives = "VicensVives",
    Brunno = "Brunno",
    Oxford = "Oxford",
    Planeta = "Planeta",
    Milton = "Milton",
    ContenidoPropio = "ContenidoPropio",
    Ramatics = "Ramatics",
    Esc = "Esc",
    Tabarca = "Tabarca",
    Bromera = "Bromera",
    Klett = "Klett",
    ElOrfebre = "ElOrfebre",
    Laberinto = "Laberinto",
    Paraninfo = "Paraninfo",
    Andana = "Andana",
    Sansy = "Sansy",
    Cornelsen = "Cornelsen",
    Tecno1218 = "Tecno1218",
}

export interface EditorialSinCredenciales {
    id: number | null;
    editorial: Editorial;
    tipoAcceso: TipoAccesoLicencia;
}

export interface EmailImportacion {
    id: number;
    email: string | null;
    usuarioId: number;
    usuario: UsuarioColegio;
}

export interface EntradaAuditoriaListItem {
    fecha: Date;
    id: number;
    tipoAuditoria: TipoAuditoria;
    usuarioAccionId: number | null;
    usuarioAccion: string | null;
    usuarioDatosId: number;
    usuarioDatos: string | null;
    itemId: number;
    descripcion: string | null;
}

export interface EntradaAuditoriaListItemPaginatedList {
    resultsPerPage: number;
    resultsCurrentPage: number;
    currentPage: number;
    totalCount: number;
    orderByColumn: string | null;
    orderMode: SortDirection;
    items: EntradaAuditoriaListItem[] | null;
}

export interface EntradaAuditoriaSearch extends SearchModelBase {
    usuarioDatosId: number | null;
    colegioId: any | null;
}

export interface Envio {
    id: number;
    pedidoId: number;
    documentoOrigen: string | null;
    estado: EstadoEnvios;
    fecha: Date;
    referenciaSeguimiento: string | null;
    transportista: Transportista;
    odooId: number | null;
    createDate: Date | null;
    lastUpdate: Date | null;
    estadoTransportista: string | null;
    fechaGeneracionEtiqueta: Date | null;
    numBultos: number | null;
    pesoParaEnvio: number | null;
    calle: string | null;
    calle2: string | null;
    city: string | null;
    compania: string | null;
    countryId: number | null;
    destinatario: string | null;
    partnerId: number | null;
    stateId: number | null;
    zip: string | null;
    telefono: string | null;
    fechaProgramadaEntrega: Date | null;
    pedido: Pedido;
    lineas: EnvioLinea[] | null;
}

export interface EnvioLinea {
    id: number;
    envioId: number;
    itemCatalogoEditorialId: number;
    numUnidades: number;
    nombre: string | null;
    odooId: number | null;
    createDate: Date | null;
    lastUpdate: Date | null;
    isbn: string | null;
    envio: Envio;
}

export interface EstadisticaListItem {
    numAccesos: number;
    dia: Date;
    contenidoId: number | null;
}

export interface GraphSearch {
    usuarioId: number | null;
    profesorId: number | null;
    licenciaContenidoIds: number[] | null;
    tipo: TipoEstadistica;
    fechaDesde: Date;
    fechaHasta: Date;
    busquedaGlobal: boolean;
    tipoUsuario: TipoUsuario;
    claseId: number[] | null;
    claseMateriaId: number | null;
    contenidosId: number[] | null;
    tipoGrafico: TipoGrafico;
}

export interface EstadisticasAccesoGraphExcelExport extends GraphSearch {
}

export interface EstadisticasAccesoGraphSearch extends GraphSearch {
}

export interface EstadisticasAccesoGraphSearchResult {
    items: EstadisticaListItem[] | null;
    fechaUltimoAcceso: Date | null;
    accesosUltimos30dias: number | null;
    accesosUltimos7dias: number | null;
    accesosUltimodia: number | null;
}

export interface EstadisticasContenidoGraphExcelExport extends GraphSearch {
}

export interface EstadisticasContenidoGraphSearch extends GraphSearch {
}

export interface EstadisticasContenidoGraphSearchResult {
    items: { [key: string]: StackedListItem[]; } | null;
    contenidos: { [key: string]: string; } | null;
    fechaUltimoAcceso: Date | null;
    accesosUltimos30dias: number | null;
    accesosUltimos7dias: number | null;
    accesosUltimodia: number | null;
    stackedGraphBar: StackedGraphBar;
}

export enum EstadoCargaItem {
    Correcto = "Correcto",
    Duplicado = "Duplicado",
    Erroneo = "Erroneo",
}

export enum EstadoCompromiso {
    Borrador = "Borrador",
    Publicado = "Publicado",
}

export enum EstadoEnvios {
    None = "None",
    Borrador = "Borrador",
    EnPreparacion = "EnPreparacion",
    PickingCompletado = "PickingCompletado",
    PalomarCompletado = "PalomarCompletado",
    ListoParaTransportista = "ListoParaTransportista",
    PickingColegioCompletado = "PickingColegioCompletado",
    PalomarColegioCompletado = "PalomarColegioCompletado",
    SalidaColegioRetenida = "SalidaColegioRetenida",
    Retenido = "Retenido",
    RecogidoTransportista = "RecogidoTransportista",
    RepartoIncidencia = "RepartoIncidencia",
    Entregado = "Entregado",
    Cancelado = "Cancelado",
}

export enum EstadoLicencia {
    Vacio = "Vacio",
    Activo = "Activo",
    PedidoCancelado = "PedidoCancelado",
    Caducada = "Caducada",
    BurlingtonActivaOk = "BurlingtonActivaOk",
    BurlingtonInvalidActivationCode = "BurlingtonInvalidActivationCode",
    BurlingtonErrorActivacion = "BurlingtonErrorActivacion",
    NecesitaSerRevisada = "NecesitaSerRevisada",
    BurlingtonDeletedUser = "BurlingtonDeletedUser",
}

export enum EstadoPedidoScholarum {
    Cancelado = "Cancelado",
    Pagado = "Pagado",
    PendientePago = "PendientePago",
    ErrorPagoTpv = "ErrorPagoTpv",
    Entregado = "Entregado",
    Formalizado = "Formalizado",
}

export enum EstadoUsuario {
    Nuevo = "Nuevo",
    PendienteValidacion = "PendienteValidacion",
    Activo = "Activo",
}

export interface EstructuraContenidosContenido {
    id: number;
    nombre: string | null;
    libros: Libro[] | null;
}

export interface Etapa {
    id: number;
    cursoEscolarId: number;
    cursoEscolar: CursoEscolar;
    nombre: string | null;
    nivelesEducativos: NivelEducativo[] | null;
    orden: number;
    sincronizar: boolean;
    omitirNotificacionLicencias: boolean;
    omitirNotificacionCredenciales: boolean;
}

export interface EtapaEditModel {
    id: number;
    cursoEscolarId: number;
    nombre: string | null;
    orden: number;
    niveles: NivelEducativoEditModel[] | null;
    sincronizar: boolean;
    omitirNotificacionLicencias: boolean;
    omitirNotificacionCredenciales: boolean;
}

export interface ExcelTemplateGetMessage {
    tipoCarga: TipoCarga;
}

export interface ExportFileResult {
    content: string | null;
    fileName: string | null;
}

export enum FormatoContenido {
    Digital = "Digital",
    Papel = "Papel",
}

export interface GetComprasPosiblesResponse {
    contenidos: ComprasPosiblesItem[] | null;
}

export interface GetContenidosExternosResult {
    contenidos: ContenidoExternoModel[] | null;
}

export interface GetEstructuraContenidosClaseMateriaResult {
    contenidos: EstructuraContenidosContenido[] | null;
}

export interface GetLicenciaAccesoUrlResponse {
    esError: boolean;
    puedeAcceder: boolean;
    mensajeUsuario: string | null;
    mensajePrevioAcceso: string | null;
    url: string;
    htmlToInject: string;
    marsupialGrupoId: number | null;
    marsupialUsuarioId: string | null;
    scriptToInject: string | null;
}

export interface GetLicenciasContenidosResponse {
    contenidos: LicenciaContenidosItem[];
}

export interface GetLicenciasSinCredencialesResponse {
    licencias: LicenciaSinCredencialItem[];
}

export interface LicenciaSinCredencialItem {
    licenciaContenidoId: number;
    titulo: string;
    clase: string | null;
    isbn: string | null;
    tipoAcceso: TipoAccesoLicencia;
}

export interface GuardarCredencialLicenciaRequest {
    userId: number;
    colegioId: number;
    licenciaId: number;
    credencial: string | null;
}

export interface GuardarCredencialLicenciaResponse {
    valida: boolean;
    comprobada: boolean;
    mensaje: string | null;
    licenciaContenidoId: number;
}

export interface GetTiposLicenciaResponse {
    tiposAcceso: TipoAccesoLicencia[] | null;
}

export interface GetUserContextResponse {
    usuarioId: number;
    login: string | null;
    nombre: string | null;
    apellidos: string | null;
    fotoUsuario: string | null;
    porcentajePerfil: number;
    tipoUsuario: TipoUsuario;
    claseActualId: number | null;
    claseActual: string | null;
    readonly isDefaultClass: boolean;
    colegioId: number;
    fotoColegio: string | null;
    nombreColegio: string | null;
    isImpersonated: boolean;
    readonly cursoEscolarActivoId: number | null;
    interfaceLanguage: InterfaceLanguage;
    cursosEscolares: CursoEscolarListItem[] | null;
}

export interface GrupoClaseEditModel {
    id: number;
    nivelEducativoId: number;
    nivelEducativo: string | null;
    nombre: string | null;
    orden: number;
    identificadorTienda: string | null;
    sincronizar: boolean;
    etapaId: number;
    etapa: string | null;
    cursoEscolarId: number;
    cursoEscolar: string | null;
    numMatriculas: number;
    numMaterias: number;
    materias: ClaseMateriaEditModel[] | null;
}

export interface InfoConexion {
    issuer: string | null;
    clientId: string | null;
    jwkSetUrl: string | null;
    accessTokenUrl: string | null;
    authorizationUrl: string | null;
}

export interface Institucion {
    id: number;
    name: string | null;
    description: string | null;
    colegios: Colegio[] | null;
}

export enum InterfaceLanguage {
    Espannol = "Espannol",
}

export interface Libro {
    id: number;
    itemCatalogoEditorialId: number | null;
    isbn: string | null;
    titulo: string | null;
    nivel: string | null;
    formato: string | null;
    unidades: Unidad[] | null;
}

export interface LicenciaContenido {
    id: number;
    matriculaId: number;
    matricula: Matricula;
    itemCatalogoEditorialId: number | null;
    esDigital: boolean | null;
    idContenidoLms: string | null;
    tipoAcceso: TipoAccesoLicencia;
    credenciales: string | null;
    numPedido: number | null;
    fechaPedido: Date | null;
    origen: OrigenLicencia;
    ultimoAcceso: Date | null;
    configuradoProveedor: Date | null;
    estado: EstadoLicencia;
    motivacionEstado: string | null;
    numLinea: number | null;
    marsupialGrupoId: number | null;
    marsupialUsuarioId: string | null;
    licenciaId: number | null;
    credencial: CredencialLicencia;
    fechaAsignacionCredenciales: Date | null;
    asignacionCredencialesNotificada: Date | null;
    asignacionLicenciaManual: boolean;
    tipoAccesoManual: TipoAccesoLicencia;
    mensajeAccesoManual: string | null;
    tipoLicencia: TipoLicencia;
}

export interface LicenciaContenidosEditModel {
    id: number;
    colegioId: number;
    matriculaId: number | null;
    matricula: string | null;
    claseId: number;
    etapaId: number;
    cursoEscolarId: number;
    clase: string | null;
    claseMateriaId: number | null;
    claseMateria: string | null;
    itemCatalogoEditorialId: number | null;
    contenido: string | null;
    esDigital: boolean;
    pedidoJsonUrl: string | null;
    isbn: string | null;
    tipoAcceso: TipoAccesoLicencia;
    tipoContenido: TipoContenido;
    tipoUsuario: TipoUsuarioContenido;
    credenciales: string | null;
    pedidoId: number;
    numPedido: number;
    fechaPedido: Date | null;
    editorial: Editorial;
    origen: OrigenLicencia;
    created: Date;
    modified: Date;
    asignacionCredencialesNotificada: Date | null;
    fechaAsignacionCredenciales: Date | null;
    usuario: string | null;
    usuarioId: number;
    fechaUltimoAcceso: Date | null;
    configuradoProveedor: Date | null;
    logsBurlington: LogSincronizacionesBurlington[] | null;
    estado: EstadoLicencia;
    asignacionLicenciaManual: boolean;
    tipoAccesoManual: TipoAccesoLicencia;
    mensajeAccesoManual: string | null;
    tipoLicencia: TipoLicencia;
    marsupialGrupoId: number | null;
    marsupialUsuarioId: string | null;
}

export interface LicenciaContenidosItem {
    licenciaContenidoId: number;
    nombre: string;
    clase: string | null;
    caratula: string | null;
    tipoAcceso: TipoAccesoLicencia;
    credenciales: string | null;
    editorial: Editorial;
    editorialNombre: string | null;
    tipoContenido: TipoContenido;
    tieneCredenciales: boolean;
    rol: TipoUsuarioContenido;
    contenidoAccesibleAlumnos: boolean;
    deshabilitarAcceso: boolean;
    puedeInteractuar: boolean;
}

export interface LicenciaSinConfigurar {
    id: number;
    usuarioId: number;
    usuario: string | null;
    contenido: string | null;
    rol: TipoUsuarioContenido;
}

export interface LicenciasContenidoDeleteMultipleModel {
    idsToDelete: number[] | null;
}

export interface LicenciasContenidosSearchBase extends SearchModelBase {
    colegioId: number;
    usuarioNombre: string | null;
    numPedido: string | null;
    fechaPedidoFrom: Date | null;
    fechaPedidoTo: Date | null;
    credenciales: string | null;
    usuarioId: number | null;
    contenidoId: number | null;
    cursoEscolarId: number | null;
    contenidoNombre: string | null;
    editorial: Editorial;
    nivelEducativoId: number | null;
    matriculaId: number | null;
    claseMateriaId: number | null;
    origen: OrigenLicencia;
    rol: TipoUsuarioContenido;
    formatoContenido: FormatoContenido;
    tieneCredenciales: boolean | null;
    tipoAcceso: TipoAccesoLicencia;
    tipoLicencia: TipoLicencia;
    asignacionLicenciaManual: boolean | null;
}

export interface LicenciasContenidosExcelExport extends LicenciasContenidosSearchBase {
}

export interface LicenciasContenidosListItem {
    id: number;
    isbn: string | null;
    contenido: string | null;
    esDigital: boolean | null;
    itemCatalogoEditorialId: number | null;
    tipoAcceso: TipoAccesoLicencia;
    usuario: string | null;
    usuarioNombre: string | null;
    usuarioApellidos: string | null;
    login: string | null;
    usuarioId: number;
    editorial: Editorial;
    cursoEscolar: string | null;
    claseId: number;
    clase: string | null;
    subgrupo: string | null;
    claseMateria: string | null;
    nivelEducativoId: number;
    nivelEducativo: string | null;
    credenciales: string | null;
    numPedido: string | null;
    fechaPedido: Date | null;
    origen: OrigenLicencia;
    fechaUltimoAcceso: Date | null;
    mostrarAccesoDirecto: boolean;
    readonly tieneError: boolean;
    readonly protegidoBorrado: boolean;
}

export interface LicenciasContenidosListItemPaginatedList {
    resultsPerPage: number;
    resultsCurrentPage: number;
    currentPage: number;
    totalCount: number;
    orderByColumn: string | null;
    orderMode: SortDirection;
    items: LicenciasContenidosListItem[] | null;
}

export interface LicenciasContenidosSearch extends LicenciasContenidosSearchBase {
}

export interface LineaPedido {
    id: number;
    pedidoId: number;
    pedido: Pedido;
    cantidadPedida: number;
    cantidadDevuelta: number;
    importeSinImpuestos: number | null;
    impuestos: number | null;
    tipoLinea: number;
    lineaPedidoPrincipalId: number | null;
}

export interface LineaPedidoTiendaListItem {
    id: number;
    cantidadPedida: number;
    cantidadDevuelta: number;
    sku: string | null;
    producto: string | null;
    tipoProducto: TipoProductoTienda;
    licencias: string | null;
}

export interface LogSincronizacionesBurlington {
    id: number;
    date: Date;
    credencial: string | null;
    colegioId: number;
    colegio: Colegio;
    usarioId: number;
    email: string | null;
    tipoAccionBurlington: TipoAccionBurlington;
    respuesta: string | null;
    peticion: string | null;
}

export interface MateriaProfesorEditModel {
    colegioId: number;
    claseMateriaId: number;
    materia: string | null;
}

export interface MateriaProfesorPersistResult {
    readonly claseMateriaId: number;
}

export interface Matricula {
    id: number;
    usuarioId: number;
    usuario: UsuarioColegio;
    claseMateriaId: number;
    claseMateria: ClaseMateria;
    fecha: Date;
    rol: TipoUsuarioContenido;
    subgrupo: string | null;
    licencias: LicenciaContenido[] | null;
}

export interface MatriculaEditBase {
    id: number;
    colegioId: number;
    usuario: string | null;
    usuarioId: number;
    clase: string | null;
    claseId: number;
    materia: string | null;
    claseMateriaId: number;
    licenciaContenidos: LicenciaContenidosItem[] | null;
    subgrupo: string | null;
    fecha: Date;
    rol: TipoUsuarioContenido;
}

export interface MatriculaEditModel extends MatriculaEditBase {
}

export interface MatriculaListItem {
    id: number;
    readonly usuario: string | null;
    usuarioNombre: string | null;
    usuarioApellidos: string | null;
    usuarioId: number;
    clase: string | null;
    claseId: number;
    materia: string | null;
    claseMateriaId: number;
    contenido: string | null;
    contenidoId: number;
    etapa: string | null;
    nivelEducativoId: number;
    fecha: Date;
    rol: TipoUsuarioContenido;
    subgrupo: string | null;
}

export interface MatriculaListItemPaginatedList {
    resultsPerPage: number;
    resultsCurrentPage: number;
    currentPage: number;
    totalCount: number;
    orderByColumn: string | null;
    orderMode: SortDirection;
    items: MatriculaListItem[] | null;
}

export interface MatriculaProfesorEditModel extends MatriculaEditBase {
}

export interface MatriculaProfesorListItem {
    id: number;
    usuario: string | null;
    usuarioId: number;
    clase: string | null;
    claseId: number;
    materia: string | null;
    claseMateriaId: number;
    contenido: string | null;
    cursoEscolar: string | null;
    contenidoId: number;
    nivelEducativo: string | null;
    nivelEducativoId: number;
    numAlumnos: number;
    rol: TipoUsuarioContenido;
}

export interface MatriculaProfesorListItemPaginatedList {
    resultsPerPage: number;
    resultsCurrentPage: number;
    currentPage: number;
    totalCount: number;
    orderByColumn: string | null;
    orderMode: SortDirection;
    items: MatriculaProfesorListItem[] | null;
}

export interface MatriculasProfesorSearch extends SearchModelBase {
    colegioId: number;
    usuarioId: number | null;
    claseId: number | null;
    claseMateriaId: number | null;
    nivelEducativoId: number | null;
}

export interface MatriculasSearch extends SearchModelBase {
    colegioId: number;
    usuarioId: number | null;
    claseId: number | null;
    claseMateriaId: number | null;
    cursoEscolarId: number;
}

export interface MatriculasSinLicencia {
    usuario: string | null;
    usuarioId: number;
    nivelEducativo: string | null;
    nivelEducativoId: number;
    clase: string | null;
    claseId: number;
    claseMateria: string | null;
    claseMateriaId: number;
    matriculaId: number;
    fechaMatricula: Date;
    rol: TipoUsuarioContenido;
}

export interface MiColegioEditModel {
    id: number;
    nombre: string | null;
    dominiosAutorizados: string | null;
    comunidadAutonomaId: number | null;
    comunidadAutonoma: string | null;
    readonly dominios: string[] | null;
    foto: string | null;
    nombreColegioPedidosTienda: string | null;
    allowedLoginMethods: string | null;
    sincronizar: boolean;
    sincronizarLicencias: boolean;
    allowGoogleLogin: boolean;
    allowMicrosoftLogin: boolean;
    allowCustomLogin: boolean;
    comunicarAsignacionLicencias: boolean;
    comunicarCredencialesLicenciasAlAsignar: boolean;
    emailColegio: string | null;
    codMinisterio: string | null;
    error: string | null;
}

export interface MiPerfilEditModel {
    id: number;
    colegioId: number;
    login: string | null;
    nombre: string | null;
    apellidos: string | null;
    foto: string | null;
    claseActualId: number | null;
    claseActual: string | null;
    password: string | null;
    passwordConfirmar: string | null;
    passwordError: string | null;
    allowCustomLogin: boolean;
}

export interface ModelValidationResult {
    isOk: boolean;
    validationErrors: { [key: string]: string; } | null;
}

export interface MovimientoEstudiantesNivelModel {
    nivelOrigenId: number;
    nivelDestinoId: number;
}

export interface NivelContenidosDeleteResult {
    errorMsg: string | null;
}

export interface NivelContenidosEditBase {
    colegioId: number;
    id: number;
    nivelEducativoId: number;
    nivelEducativo: string | null;
    contenido: string | null;
    contenidoId: number;
    mensajeAcceso: string | null;
    editorial: Editorial;
    tipoAccesoPorDefecto: TipoAccesoLicencia;
    mostrarAccesoDirecto: boolean;
}

export interface NivelContenidosEditModel extends NivelContenidosEditBase {
}

export interface NivelContenidosListItem {
    id: number;
    contenido: string | null;
    isbn: string | null;
    contenidoId: number;
    nivelEducativo: string | null;
    nivelEducativoId: number;
    etapa: string | null;
    tipoAccesoPorDefecto: TipoAccesoLicencia;
    numLicencias: number;
}

export interface NivelContenidosListItemPaginatedList {
    resultsPerPage: number;
    resultsCurrentPage: number;
    currentPage: number;
    totalCount: number;
    orderByColumn: string | null;
    orderMode: SortDirection;
    items: NivelContenidosListItem[] | null;
}

export interface NivelContenidosSearch extends SearchModelBase {
    colegioId: number;
    cursoEscolarId: number;
    nivelId: number | null;
    claseId: number | null;
    contenidoId: number | null;
}

export interface NivelEducativo {
    id: number;
    etapaId: number;
    etapa: Etapa;
    nombre: string | null;
    nombreMagento: string | null;
    clases: Clase[] | null;
    numeroEstimadoAlumnos: number | null;
    porcentajeEstimacionCompra: number | null;
    porcentajeCompraHistorico: number | null;
    numeroAlumnosTotal: number | null;
    numeroAlumnosGratuidad: number | null;
    numeroAlumnosPrevisionCompra: number | null;
    asignacionesListasLibros: AsignacionListaLibros[] | null;
    orden: number;
    sincronizar: boolean;
    omitirCreacionListas: boolean;
    omitirNotificacionLicencias: boolean;
    omitirNotificacionCredenciales: boolean;
}

export interface NivelEducativoDependenciasModel {
    nivelEducativoId: number;
    nombre: string | null;
    estudiantesTienda: number;
    matriculas: number;
    matriculasDeUsuariosDeBaja: number;
    alumnosConClaseActual: number;
    alumnosConClaseActualDeBaja: number;
    clases: number;
    materias: number;
    contenidos: number;
    asignacionesListasLibros: number;
    itemsListasLibros: number;
    readonly borradoBloqueado: boolean;
    readonly requiereMoverEstudiantes: boolean;
}

export interface NivelEducativoDestinoListItem {
    nivelEducativoId: number;
    nivelEducativo: string | null;
    etapaId: number;
    etapa: string | null;
    cursoEscolarId: number;
    cursoEscolar: string | null;
    cursoEscolarActivo: boolean;
    numEstudiantes: number;
}

export interface NivelEducativoEditModel {
    id: number;
    etapaId: number;
    nombre: string | null;
    orden: number;
    numContenidosDigitales: number;
    numContenidosPapel: number;
    clases: GrupoClaseEditModel[] | null;
    sincronizar: boolean;
    omitirNotificacionLicencias: boolean;
    omitirNotificacionCredenciales: boolean;
}

export interface NivelProductosTiendaSearch extends SearchModelBase {
    colegioId: number;
    cursoEscolarId: number;
    nivelId: number | null;
    claseId: number | null;
    productoTiendaId: number | null;
}

export interface NivelProductosTiendasListItem {
    id: number;
    productoTienda: string | null;
    productoTiendaId: number;
    productoTiendaSku: string | null;
    nivelEducativo: string | null;
    nivelEducativoId: number;
}

export interface NivelProductosTiendasListItemPaginatedList {
    resultsPerPage: number;
    resultsCurrentPage: number;
    currentPage: number;
    totalCount: number;
    orderByColumn: string | null;
    orderMode: SortDirection;
    items: NivelProductosTiendasListItem[] | null;
}

export enum OrigenLicencia {
    Administrador = "Administrador",
    Tienda = "Tienda",
    CargaFichero = "CargaFichero",
}

export enum OrigenPedido {
    Tienda = "Tienda",
    Colegio = "Colegio",
}

export enum OrigenUsuario {
    Administrador = "Administrador",
    Tienda = "Tienda",
    CargaFichero = "CargaFichero",
    AddinGoogle = "AddinGoogle",
}

export interface Pedido {
    id: number;
    campannaId: number;
    campanna: Campanna;
    externalId: number;
    colegioId: number;
    colegio: Colegio;
    fechaPedido: Date;
    direccionEnvio: string | null;
    estadoPedidoScholarum: EstadoPedidoScholarum;
    emailCliente: string | null;
    nombreCliente: string | null;
    descuento: number | null;
    descripDescuento: string | null;
    cupones: string | null;
    numLicencias: number | null;
    procesadoTiendaV2: Date | null;
    lineas: LineaPedido[] | null;
    numComprasConLicencia: number;
    importeSinImpuestos: number | null;
    impuestos: number | null;
    peso: number | null;
    pendienteRevision: boolean;
    notasRevision: string | null;
    noSincronizar: boolean;
}

export interface PedidoLineaTiendaListItem {
    id: number;
    pedidoId: number;
    numPedido: number;
    colegio: string | null;
    nombreCliente: string | null;
    estudiante: string | null;
    clase: string | null;
    cursoAlumno: string | null;
    fechaPedido: Date;
    isbn: string | null;
    titulo: string | null;
    unidades: number;
    estadoPedidoScholarum: EstadoPedidoScholarum;
}

export interface PedidoLineaTiendaListItemPaginatedList {
    resultsPerPage: number;
    resultsCurrentPage: number;
    currentPage: number;
    totalCount: number;
    orderByColumn: string | null;
    orderMode: SortDirection;
    items: PedidoLineaTiendaListItem[] | null;
}

export interface PedidoTiendaDetailResult {
    id: number;
    colegioId: number;
    nombreCliente: string | null;
    emailCliente: string | null;
    nombrePresupuesto: string | null;
    fechaPresupuesto: Date | null;
    procesadoTiendaV2: Date | null;
    fechaPedido: Date;
    cupones: string | null;
    descripDescuento: string | null;
    descuento: number | null;
    direccionEnvio: string | null;
    estadoPedidoScholarum: EstadoPedidoScholarum;
    items: LineaPedidoTiendaListItem[] | null;
    licenciasExtra: PedidoTiendaLicenciaExtraListItem[] | null;
    envios: Envio[] | null;
    noSincronizar: boolean;
}

export interface PedidosTiendaSearchBase extends SearchModelBase {
    colegioId: number | null;
    pedidoId: number | null;
    numPedido: number | null;
    origen: OrigenPedido;
    nombreCliente: string | null;
    nombre: string | null;
    fechaPresupuestoFrom: Date | null;
    fechaPresupuestoTo: Date | null;
    nombreUsuario: string | null;
    estadoPedidoScholarum: EstadoPedidoScholarum;
    fechaCompraFrom: Date | null;
    fechaCompraTo: Date | null;
    sku: string | null;
    conDescuento: boolean | null;
}

export interface PedidoTiendaInformeCompletoMessage extends PedidosTiendaSearchBase {
}

export interface PedidoTiendaLicenciaExtraListItem {
    contenido: string | null;
    isbn: string | null;
    usuario: string | null;
    usuarioId: number;
    licenciaContenidoId: number;
}

export interface PedidoTiendaListItem {
    id: number;
    colegio: string | null;
    nombreCliente: string | null;
    fechaPedido: Date;
    descripDescuento: string | null;
    cupones: string | null;
    descuento: number | null;
    estadoPedidoScholarum: EstadoPedidoScholarum;
    licencias: string | null;
    nombre: string | null;
    fechaPresupuesto: Date | null;
    numItems: number;
}

export interface PedidoTiendaListItemPaginatedList {
    resultsPerPage: number;
    resultsCurrentPage: number;
    currentPage: number;
    totalCount: number;
    orderByColumn: string | null;
    orderMode: SortDirection;
    items: PedidoTiendaListItem[] | null;
}

export interface PedidosLineasTiendaSearchBase extends SearchModelBase {
    colegioId: number | null;
    numPedido: number | null;
    nombreCliente: string | null;
    nombreEstudiante: string | null;
    sku: string | null;
    estadoPedidoScholarum: EstadoPedidoScholarum;
    fechaCompraFrom: Date | null;
    fechaCompraTo: Date | null;
}

export interface PedidosLineasTiendaExcelExport extends PedidosLineasTiendaSearchBase {
}

export interface PedidosLineasTiendaSearch extends PedidosLineasTiendaSearchBase {
}

export interface PedidosTiendaExcelExport extends PedidosTiendaSearchBase {
}

export interface PedidosTiendaSearch extends PedidosTiendaSearchBase {
}

export interface Photo {
    small: string | null;
    original: string | null;
}

export interface ResolucionConflictoCredencial {
    licenciaEliminarId: number;
    licenciaDestinoId: number;
    resolucion: ResolucionConflictoUnion;
}

export enum ResolucionConflictoUnion {
    ConservarDestino = "ConservarDestino",
    ConservarEliminado = "ConservarEliminado",
    Ninguna = "Ninguna",
}

export interface ResultadoActividad {
    id: number;
    idResultadoRaw: number;
    colegioId: number;
    colegio: Colegio;
    fechaActividad: Date;
    matriculaId: number;
    matricula: Matricula;
    actividadId: number;
    actividad: Actividad;
    calificacion: number;
    intentos: number;
    urlResultados: string | null;
}

export interface ResultadosCargaLicenciasExcelExport {
    cargaId: number | null;
    estadoCarga: EstadoCargaItem;
}

export interface ResultadosCargaUsuariosExcelExport {
    cargaId: number | null;
    estadoCarga: EstadoCargaItem;
}

export enum SortDirection {
    Asc = "Asc",
    Desc = "Desc",
}

export interface StackedGraphBar {
    name: string | null;
    rgbColor: string | null;
}

export interface StackedListItem {
    contenidoId: number;
    numAccesos: number;
    contenido: string | null;
    dia: string | null;
}

export enum TipoAccesoLicencia {
    Custom = "Custom",
    Marsupial = "Marsupial",
    MarsupialBlink = "MarsupialBlink",
    SinAcceso = "SinAcceso",
    MacMillanLive = "MacMillanLive",
    AccesoManual = "AccesoManual",
    BlinkDirecto = "BlinkDirecto",
    Lti11 = "Lti11",
    NoAccedeSiMuestraCredenciales = "NoAccedeSiMuestraCredenciales",
    NoAccedeNoMuestraCredenciales = "NoAccedeNoMuestraCredenciales",
    NoAccedeMuestraMensaje = "NoAccedeMuestraMensaje",
    SantillanaPrisma = "SantillanaPrisma",
    Lti13 = "Lti13",
    SantillanaAV4 = "SantillanaAV4",
    SantillanaJWE = "SantillanaJWE",
    SinConfigurar = "SinConfigurar",
}

export enum TipoAccionBurlington {
    Sincronizar = "Sincronizar",
    BorrarUsuario = "BorrarUsuario",
}

export enum TipoAuditoria {
    Ninguno = "Ninguno",
    CrearLicencia = "CrearLicencia",
    BorrarLicencia = "BorrarLicencia",
    ModificarLicencia = "ModificarLicencia",
    MoverEstudiantesNivel = "MoverEstudiantesNivel",
    BorrarUsuario = "BorrarUsuario",
    RecuperarUsuario = "RecuperarUsuario",
    UnirUsuarios = "UnirUsuarios",
}

export enum TipoCarga {
    Usuario = "Usuario",
    Licencia = "Licencia",
}

export enum TipoCompromiso {
    Gratuidad = "Gratuidad",
    Tienda = "Tienda",
}

export enum TipoContenido {
    Licencia = "Licencia",
    Virtual = "Virtual",
}

export enum TipoEstadistica {
    AccesoUsuario = "AccesoUsuario",
    AccesoContenido = "AccesoContenido",
    ErrorAccesoContenido = "ErrorAccesoContenido",
}

export enum TipoGrafico {
    Global = "Global",
    Usuario = "Usuario",
    Licencia = "Licencia",
    Profesor = "Profesor",
}

export enum TipoLicencia {
    Tiendas = "Tiendas",
    Gratuidad = "Gratuidad",
    HijosProfesores = "HijosProfesores",
    Repetidores = "Repetidores",
    ManualAlumno = "ManualAlumno",
}

export enum TipoProductoTienda {
    Simple = "Simple",
    Virtual = "Virtual",
    Grouped = "Grouped",
    License = "License",
}

export enum TipoUsuario {
    None = "None",
    Alumno = "Alumno",
    Profesor = "Profesor",
    AdminColegio = "AdminColegio",
    AdminGlobal = "AdminGlobal",
    AdminInstitucion = "AdminInstitucion",
    VisorPedidos = "VisorPedidos",
}

export enum TipoUsuarioContenido {
    Alumno = "Alumno",
    Profesor = "Profesor",
}

export interface NormalizarLicenciasPorRolMessage {
    colegioId: number;
    cursoEscolarId: number;
    simular: boolean;
}

export interface NormalizarLicenciasPorRolResponse {
    simulado: boolean;
    licenciasBorradas: number;
    licenciasConservadasPorCredencial: number;
    matriculasBorradas: number;
    matriculasConservadasPorActividad: number;
    usuariosAfectados: number;
    aBorrar: NormalizarLicenciasPorRolDetalle[] | null;
    conservadasPorCredencial: NormalizarLicenciasPorRolDetalle[] | null;
}

export interface NormalizarLicenciasPorRolDetalle {
    licenciaId: number;
    usuario: string | null;
    tipoUsuario: TipoUsuario;
    tipoUsuarioContenido: TipoUsuarioContenido;
    clase: string | null;
    claseMateria: string | null;
    contenido: string | null;
    isbn: string | null;
}

export interface BuscarAnomaliasBurlingtonMessage {
    colegioId: number;
    cursoEscolarId: number;
}

export interface BuscarAnomaliasBurlingtonResponse {
    desde: Date;
    hasta: Date | null;
    totalHuerfanas: number;
    totalEmailDistinto: number;
    huerfanas: AnomaliaBurlington[] | null;
    emailDistinto: AnomaliaBurlington[] | null;
}

export interface AnomaliaBurlington {
    logId: number;
    fecha: Date;
    tipoAccionBurlington: TipoAccionBurlington;
    email: string | null;
    credencial: string | null;
    usuarioId: number;
    usuarioRelacionadoId: number | null;
    usuario: string | null;
    loginUsuario: string | null;
    licenciaId: number | null;
    isbn: string | null;
}

export interface ExportarAnomaliasBurlingtonMessage {
    colegioId: number;
    cursoEscolarId: number;
}

export interface EnviarAnomaliasBurlingtonPorCorreoMessage {
    colegioId: number;
    cursoEscolarId: number;
    email: string | null;
}

export interface EnviarAnomaliasBurlingtonPorCorreoResponse {
    email: string | null;
    logIds: number[] | null;
}

export interface LimpiarCuentasBurlingtonMessage {
    colegioId: number;
    cursoEscolarId: number;
    logIds: number[] | null;
}

export interface LimpiarCuentasBurlingtonResponse {
    borrados: ResultadoBorradoBurlington[] | null;
    excluidosUsuarioColegio: string[] | null;
    excluidosYaBorrados: string[] | null;
}

export interface ResultadoBorradoBurlington {
    email: string | null;
    isOk: boolean;
    respuesta: string | null;
}

export enum Transportista {
    None = "None",
    CorreosExpress = "CorreosExpress",
    LocalPickup = "LocalPickup",
    DHL = "DHL",
    Otros = "Otros",
}

export interface Unidad {
    id: number;
    externalId: string | null;
    libroId: number;
    libro: Libro;
    nombre: string | null;
    orden: number;
    actividades: Actividad[] | null;
}

export interface UnionUsuariosPlan {
    errorMsg: string | null;
    readonly isOk: boolean;
    esPosible: boolean;
    bloqueos: string[] | null;
    avisos: string[] | null;
    origen: UsuarioColegioResumen;
    destino: UsuarioColegioResumen;
    cursoActual: ContadoresUnionUsuariosColegio;
    cursosAnteriores: ContadoresUnionUsuariosColegio;
    conflictosCursoActual: ConflictoCredencialUnion[] | null;
    conflictosCursosAnteriores: ConflictoCredencialUnion[] | null;
    destinoBorrado: boolean;
    aliasEmailAAnadir: string | null;
    huellaPlan: string | null;
}

export interface UnionUsuariosResultado {
    errorMsg: string | null;
    readonly isOk: boolean;
    usuarioDestinoId: number;
    loginDestino: string | null;
    loginOrigen: string | null;
    matriculasTraspasadas: number;
    matriculasAbsorbidas: number;
    licenciasClonadas: number;
    licenciasCompletadas: number;
    licenciasDescartadas: number;
    conflictosResueltos: number;
    credencialesLiberadas: number;
    aliasEmailOrigenAnadido: boolean;
    destinoRecuperado: boolean;
    log: string[] | null;
}

export interface UsuarioColegio {
    id: number;
    colegioId: number;
    colegio: Colegio;
    login: string | null;
    nombre: string | null;
    apellidos: string | null;
    foto: Photo;
    tipoUsuario: TipoUsuario;
    claseActualId: number | null;
    claseActual: Clase;
    fechaUltimoAcceso: Date | null;
    estado: EstadoUsuario;
    origen: OrigenUsuario;
    borrado: boolean;
    matriculas: Matricula[] | null;
    emailsImportacion: EmailImportacion[] | null;
    cargas: Carga[] | null;
}

export interface UsuarioColegioResumen {
    id: number;
    login: string | null;
    nombre: string | null;
    apellidos: string | null;
    borrado: boolean;
    tipoUsuario: TipoUsuario;
    estado: EstadoUsuario;
    fechaUltimoAcceso: Date | null;
    numMatriculas: number;
    numLicencias: number;
    numLicenciasConCredenciales: number;
    numEstudiantes: number;
    numAliasEmail: number;
    clasesCursoActual: string[] | null;
}

export interface UsuarioInfo {
    id: number;
    nombre: string | null;
}

export interface ValidateColegioUsuarioEditModel extends ColegioUsuarioBaseModel {
}

export interface ValidateMatriculaEditModel extends MatriculaEditBase {
}

export interface ValidateMatriculaProfesorEditModel extends MatriculaEditBase {
}

export interface ValidateNivelContenidosEditModel extends NivelContenidosEditBase {
}

export enum YesNo {
    Yes = "Yes",
    No = "No",
}